import { PureComponent } from 'react';
import { currency } from 'services/currency';
import * as styles from '../../styles';

export default class ServicesTableRow extends PureComponent {
  render() {
    const {
      item,
      activeServicesList,
      removeActiveService,
      addActiveService
    } = this.props;
    const isActive =
      activeServicesList &&
      activeServicesList.find(i => i.serviceId === item.id);

    return (
      <styles.Row
        key={item.id}
        isActive={isActive}
        onClick={() => {
          isActive ? removeActiveService(item) : addActiveService(item);
        }}
      >
        {/* name */}

        <styles.CellTD width="47%">
          <div align="left">{item.name}</div>
        </styles.CellTD>

        {/* nomenclature */}

        <styles.CellTD width="31%">
          <styles.TableNumber>{item.nomenclature}</styles.TableNumber>
        </styles.CellTD>

        {/* currency */}

        <styles.CellTD width="15%">
          <div align="left">{currency(item.price || 0).format()}</div>
        </styles.CellTD>

        {/* activity icons */}

        <styles.CellTD width="7%" style={{ padding: 0 }}>
          {isActive ? <styles.CancelIcon /> : <styles.AddIcon />}
        </styles.CellTD>
      </styles.Row>
    );
  }
}
